declare namespace $ {

	export class $shm_hitalama_map_touch extends $mol_touch {
	}
	
}

//# sourceMappingURL=touch.view.tree.d.ts.map